
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/predictions/make",
      function () {
        return require("private-next-pages/predictions/make.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/predictions/make"])
      });
    }
  